import { action, ActionType } from "typesafe-actions";
import { IError } from "../../../../../redux/actions/errorHandlingAction";
import { BriefProductForm } from "../../../../../features/products/types/brief-product-form/brief-product-form.interface";
import { IBriefProduct } from "../../../../../types/product/ibrief-product/ibrief-product.interface";

export enum WorkOrderProductsActions {
  AddProduct = "WorkOrderProducts/AddProduct",
  AddProductFailure = "WorkOrderProducts/AddProductFailure",
  AddProductSuccess = "WorkOrderProducts/AddProductSuccess",

  FetchProducts = "WorkOrderProducts/FetchProducts",
  FetchProductsFailure = "WorkOrderProducts/FetchProductsFailure",
  FetchProductsSuccess = "WorkOrderProducts/FetchProductsSuccess",

  Reset = "WorkOrderProducts/Reset",

  UpdateProducts = "WorkOrderProducts/UpdateProducts",
  UpdateProductsFailure = "WorkOrderProducts/UpdateProductsFailure",
  UpdateProductsSuccess = "WorkOrderProducts/UpdateProductsSuccess",
}

export const addProduct = (product: number, workOrderId: number) =>
  action(WorkOrderProductsActions.AddProduct, { product, workOrderId });
export const addProductFailure = (error: IError) =>
  action(WorkOrderProductsActions.AddProductFailure, error);
export const addProductSuccess = (product: IBriefProduct) =>
  action(WorkOrderProductsActions.AddProductSuccess, product);

export const fetchProducts = (workOrderId: number) =>
  action(WorkOrderProductsActions.FetchProducts, { workOrderId });
export const fetchProductsFailure = (error: IError) =>
  action(WorkOrderProductsActions.FetchProductsFailure, error);
export const fetchProductsSuccess = (products: IBriefProduct[]) =>
  action(WorkOrderProductsActions.FetchProductsSuccess, products);

export const reset = () => action(WorkOrderProductsActions.Reset);

export const updateProducts = (products: BriefProductForm[], workOrderId: number) =>
  action(WorkOrderProductsActions.UpdateProducts, { products, workOrderId });
export const updateProductsFailure = (error: IError) =>
  action(WorkOrderProductsActions.UpdateProductsFailure, error);
export const updateProductsSuccess = (products: IBriefProduct[]) =>
  action(WorkOrderProductsActions.UpdateProductsSuccess, products);

const actionCreators = {
  addProduct,
  addProductFailure,
  addProductSuccess,

  fetchProducts,
  fetchProductsFailure,
  fetchProductsSuccess,

  reset,

  updateProducts,
  updateProductsSuccess,
  updateProductsFailure,
};

export type WorkOrderProductsActionType = ActionType<typeof actionCreators>;
